export const contractOptions = [
    { ID: 1, NAME: 'Contr1' },
    { ID: 2, NAME: 'Contr2' },
    { ID: 3, NAME: 'Contr3' },
    { ID: 4, NAME: 'Contr4' },
    { ID: 5, NAME: 'Contr5' },
    { ID: 6, NAME: 'Contr6' },
    { ID: 7, NAME: 'Contr7' },
];